import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import {
    editPage,
    getPage,
    getPages,
} from 'redux/actions/pagesActions';
import TextFieldGroup from 'components/common/TextFieldGroup'
import SelectFieldGroup from 'components/common/SelectFieldGroup'
import Header from 'components/layout/Partials/Header'
import axios from 'axios'
import Loading from 'components/common/Loading'
import TextAreaFieldGroup from 'components/common/TextAreaFieldGroup'
import { Theme } from 'utils/Theme'
import { withStyles } from '@material-ui/styles'
import AdminLayout from 'components/layout/AdminLayout'
import { ToastsStore } from 'react-toasts';

const styles = Theme()

class DeletePage extends Component {
  constructor(props) {
    super(props)
    this.state = {
      createdBy: this.props.auth.user.id,
      parent: '',
      title: '',
      status: '',
      description: '',
      qsApp: '',
      parentPageOptions: [],
      menu: '',
      template: '',
      errors: {},
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //CHECK FOR ERRORS
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors })
    }
    if (nextProps.pages.pages) {
      const options = []
      const pages = nextProps.pages.pages

      for (let page of pages) {
        options.push({ key: page._id, title: page.title })
      }
      this.setState({ parentPageOptions: options })
    }

    if (nextProps.pages.page) {
      const page = nextProps.pages.page

      this.setState({
        parent: page.parent,
        title: page.title,
        status: page.status,
        description: page.description,
        qsApp: page.qsApp,
        menu: page.menu,
        template: page.template,
      })
    }
  }

  componentDidMount() {
    this.props.getPage(this.props.match.params.id)
    this.props.getPages()
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

    onSubmit = (e) => {
        e.preventDefault();
        this.deletePage(this.props.match.params.id);
    };

    deletePage = (id) => {
        axios
            .delete(`/api/pages/${id}`)
            .then(() => {
                ToastsStore.success(
                    'Page and all associated objects deleted successfully'
                );
                this.props.history.goBack();
            })
            .catch(() => {
                ToastsStore.error('Error deleting page');
            });
    };

  render() {
    const { errors } = this.state
    const templates = [
      { key: 'dashboard', title: 'Dashboard' },
      { key: 'analysis', title: 'Analysis' },
      { key: 'report', title: 'Report' },
    ]
    const { pages, classes } = this.props

    return (
      <AdminLayout>
        <div className="o-page">
          <Header>
            <h2 className="c-navbar__title">Delete Page</h2>
          </Header>
          <div className="container">
            {pages.loading || pages.page === null ? (
              <Loading />
            ) : (
              <div className="row">
                <div className="col-md-9 col-xl-9 u-m-auto">
                  <div className="c-card">
                    <div className="o-line c-card__title">
                      <h4 className={`c-card__title ${classes.colorSecondary}`}>
                        Confirm Delete : <small>{this.state.title}</small>
                      </h4>
                      <div>
                        <button
                          className={`c-btn ${classes.buttonSecondary}`}
                          onClick={e => this.props.history.goBack()}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>

                    <hr className="u-mt-small u-mb-medium" />
                    <form noValidate onSubmit={this.onSubmit}>
                      <div className="row">
                        <div className="col-md-6">
                          <TextFieldGroup
                            label="Title"
                            type="text"
                            onChange={this.onChange}
                            value={this.state.title}
                            name="title"
                            disabled={true}
                            error={errors.title}
                          />
                        </div>
                        <div className="col-md-6">
                          <SelectFieldGroup
                            label="Status"
                            type="text"
                            onChange={this.onChange}
                            value={this.state.status}
                            options={[
                              {
                                key: 'draft',
                                title: 'Draft',
                              },
                              {
                                key: 'published',
                                title: 'Published',
                              },
                            ]}
                            name="status"
                            disabled={true}
                            error={errors.status}
                          />
                        </div>
                        <div className="col-md-6">
                          <SelectFieldGroup
                            label="Parent"
                            type="text"
                            onChange={this.onChange}
                            value={this.state.parent}
                            options={this.state.parentPageOptions}
                            name="parent"
                            disabled={true}
                            error={errors.parent}
                          />
                        </div>

                        <div className="col-md-6">
                          <SelectFieldGroup
                            label="Menu Visibility"
                            type="text"
                            onChange={this.onChange}
                            options={[
                              {
                                key: 'yes',
                                title: 'Show',
                              },
                              {
                                key: 'no',
                                title: 'Hide',
                              },
                            ]}
                            value={this.state.menu}
                            name="menu"
                            disabled={true}
                            error={errors.menu}
                          />
                        </div>
                        <div className="col-md-6">
                          <SelectFieldGroup
                            label="Template"
                            type="text"
                            onChange={this.onChange}
                            value={this.state.template}
                            options={templates}
                            disabled={true}
                            name="template"
                            error={errors.template}
                          />
                        </div>

                        <div className="col-md-12">
                          <TextAreaFieldGroup
                            label="Description"
                            type="text"
                            onChange={this.onChange}
                            value={this.state.description}
                            name="description"
                            disabled={true}
                            error={errors.description}
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <div className="o-line">
                            <button className={`c-btn ${classes.buttonDanger}`}>Confirm Page Delete</button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </AdminLayout>
    )
  }
}

DeletePage.propTypes = {
  auth: PropTypes.object.isRequired,
  pages: PropTypes.object.isRequired,
  editPage: PropTypes.func.isRequired,
  getPage: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  match: PropTypes.object,
  getPages: PropTypes.func,
  history: PropTypes.object,
  classes: PropTypes.object,
}

const mapStateToProps = state => ({
  auth: state.auth,
  pages: state.pages,
  errors: state.errors,
})

export default connect(mapStateToProps, {
  editPage,
  getPages,
  getPage,
})(withRouter(withStyles(styles)(DeletePage)))
